import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Router } from '@angular/router';
import { apiRoutes } from '../../constants/constants';
import { NotificationService } from '../notification.service';
import { IServicioData } from '../../interfaces/interfaces';

@Injectable({ providedIn: 'root' })
export class ServicioService 
{
  constructor(private http: HttpClient, private notificationService: NotificationService,private loaderService: NgxUiLoaderService) {
  }


  getData() 
  {
    this.loaderService.start();
    return new Promise((resolve, reject) => {
      this.http.get(apiRoutes.ROUTE_SERVICIO).subscribe(
      (response: any) => {
        let success = this.notificationService.verifyStatus(response, false);
        this.loaderService.stop();
        if(success) resolve(response.data);
        resolve(null);
      },
      (error: any) => {
        this.notificationService.error(error);
        this.loaderService.stop();
        reject(error);
      });
    });
  }

  sendData(objServicio: IServicioData) 
  {
    this.loaderService.start();
    let method = objServicio.ServicioId ? 'put' : 'post';
    return new Promise((resolve, reject) => {
      this.http[method](apiRoutes.ROUTE_SERVICIO, objServicio).subscribe(
      (response: any) => {
        let success = this.notificationService.verifyStatus(response, true);
        this.loaderService.stop();
        resolve(success);
      },
      (error: any) => {
        this.notificationService.error(error);
        this.loaderService.stop();
        reject(error);
      });
    });
  }

  deleteData(servicioId: number) 
  {
    this.loaderService.start();
    return new Promise((resolve, reject) => {
      this.http.delete(apiRoutes.ROUTE_SERVICIO + '/' + servicioId).subscribe(
      (response: any) => {
        let success = this.notificationService.verifyStatus(response, true);
        this.loaderService.stop();
        resolve(success);
      },
      (error: any) => {
        this.notificationService.error(error);
        this.loaderService.stop();
        reject(error);
      });
    });
  }
}